// ============================================================
// Protocol
// ============================================================

export const PROTOCOL_VERSION = 1
export const APP_ID = 'mrmr-v1'

// ============================================================
// Nostr Relays
// ============================================================

export const NOSTR_RELAYS: readonly string[] = [
  'wss://relay.damus.io',
  'wss://nos.lol',
  'wss://relay.nostromo.social',
  'wss://nostr.data.haus',
  'wss://relay.fountain.fm',
]

export const NOSTR_RELAY_REDUNDANCY = 3

// ============================================================
// ICE Servers
// ============================================================

export const ICE_SERVERS: readonly RTCIceServer[] = [
  { urls: 'stun:stun.l.google.com:19302' },
  { urls: 'stun:stun1.l.google.com:19302' },
]

// ============================================================
// Room Derivation Labels
// ============================================================

export const ROOM_DERIVATION_LABEL = 'mrmr-room-v1'
export const SIGNALING_KEY_LABEL = 'mrmr-signaling-v1'

// ============================================================
// DataChannels (pre-negotiated)
// ============================================================

export const DATACHANNEL_SIGNALING = {
  id: 0,
  label: 'signaling',
  negotiated: true,
  ordered: true,
  protocol: 'mrmr-signaling',
} as const

export const DATACHANNEL_CRYPTO = {
  id: 1,
  label: 'crypto',
  negotiated: true,
  ordered: true,
  protocol: 'mrmr-crypto',
} as const

export const DATACHANNEL_HEALTH = {
  id: 2,
  label: 'health',
  negotiated: true,
  ordered: false,
  maxRetransmits: 0,
} as const

export const MAX_MESSAGE_SIZE = 65_536

// ============================================================
// Heartbeat
// ============================================================

export const HEARTBEAT_INTERVAL_MS = 2_000
export const HEARTBEAT_TIMEOUT_MS = 6_000
export const HEARTBEAT_DEAD_MS = 10_000

// ============================================================
// ICE Restart
// ============================================================

export const ICE_RESTART_BACKOFF_MS: readonly number[] = [1_000, 2_000, 4_000, 8_000, 16_000]
export const ICE_RESTART_MAX_ATTEMPTS = 5
export const ICE_DISCONNECT_GRACE_MS = 5_000

// ============================================================
// Meeting Limits
// ============================================================

export const MAX_PARTICIPANTS = 8

// ============================================================
// Proof of Work
// ============================================================

export const POW_DIFFICULTY = 22

// ============================================================
// Sender Keys (E2E Encryption)
// ============================================================

export const SENDER_KEY_LENGTH = 256
export const SENDER_KEY_GRACE_PERIOD_MS = 10_000
export const PREV_EPOCH_EXPIRY_MS = 30_000
